import { Component, OnInit } from '@angular/core';
import { FieldArrayType } from '@ngx-formly/core';
import { MatLegacyDialog as MatDialog } from '@angular/material/legacy-dialog';
import {CommonDialogComponent} from 'src/app/common-dialog/common-dialog.component';
import { NoopScrollStrategy } from '@angular/cdk/overlay';


@Component({
  selector: 'app-table-repeat-child-component',
  templateUrl: './table-repeat-child-component.component.html',
  styleUrls: ['./table-repeat-child-component.component.scss']
})
export class TableRepeatChildComponentComponent extends FieldArrayType   {
  constructor(private dialog: MatDialog) {
    super();
  }

  openConfirmationDialog(index: number): void {
    const dialogRef = this.dialog.open(CommonDialogComponent, {
      data: {
        title: 'Confirm Action',
        content: 'Are you sure you want to remove this row?',
        deleteRepeatSectionRow: "yes",
        image: 'warning',
        buttons: [
          {
            'title': 'Remove',
            'type': 'remove',
          },
          {
            'title' : 'Cancel',
            'type': 'no-change',
           // 'meta': "",
           // 'class': "confirm-dialog-proceed",
          }
        ]
      },
      //disableClose: true,
      scrollStrategy: new NoopScrollStrategy()
    });
  
    dialogRef.afterClosed().subscribe(result => {
      if (result) {
        this.remove(index);
        if (this.field.fieldGroup.length === 0) {
          this.add();
        }
      }
    });
  }


}
